var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93644 0.95752C3.26978 0.95752 0.269775 3.95752 0.269775 7.62419C0.269775 11.2909 3.26978 14.2909 6.93644 14.2909C10.6031 14.2909 13.6031 11.2909 13.6031 7.62419C13.6031 3.95752 10.6031 0.95752 6.93644 0.95752ZM6.93644 12.9575C3.99644 12.9575 1.60311 10.5642 1.60311 7.62419C1.60311 4.68419 3.99644 2.29085 6.93644 2.29085C9.87644 2.29085 12.2698 4.68419 12.2698 7.62419C12.2698 10.5642 9.87644 12.9575 6.93644 12.9575ZM9.99644 4.67752L5.60311 9.07085L3.87644 7.35085L2.93644 8.29085L5.60311 10.9575L10.9364 5.62419L9.99644 4.67752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCheck);
export default __webpack_public_path__ + "static/media/copy_check.f50ed5ab4efa01b146c561be5b3e6661.svg";
export { ForwardRef as ReactComponent };